module.exports = __webpack_public_path__ + "49b46280a9dace7df276061eea2a61e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/diyicaijin_h.png
// module id = 287
// module chunks = 3